<template>
  <div class="time-curve-wrapper">
    <div class="card wrapper" :class="timeCurveTopDate ? 'zoomed' : ''">
      <div class="card-header">
        <div class="header-title">Courbe temporelle des publications</div>
        <div class="header-tools">
          <DownloadButton @click="downloadAsExcel" />
          <RadioButtons
            :options="intervalsOptions"
            :active-option="timeCurveInterval"
            @select-option="changeInterval"
          />
        </div>
      </div>
      <div v-if="isTimeCurveLoading" class="loading-wrapper">
        <MinerveOrbite />
      </div>
      <NoData v-if="!isTimeCurveLoading && !timeCurve" />
      <GenericTimeCurve
        v-else-if="!isTimeCurveLoading && timeCurve"
        :data="timeCurve"
        :platforms="indexesFilters"
        :interval="timeCurveInterval"
        @update-top-date="updateTopDate"
      />
    </div>
    <div v-if="timeCurveTopDate" class="zoom-wrapper">
      <GenericTimeCurveZoom
        :interval="timeCurveInterval"
        :top-date="timeCurveTopDate"
        :top-articles="timeCurveTopArticles"
        :top-articles-filters="timeCurveTopArticlesFilters"
        :top-publications="timeCurveTopPublications"
        :top-publications-count="timeCurveTopPublicationsCount"
        :top-articles-count="timeCurveTopArticlesCount"
        :is-publications-loading="isTimeCurvePublicationsLoading"
        @update-top-articles-filters="updateTopArticlesFilters"
        @update-publications-filters="updatePublicationsFilters"
        @closes-zoom="closeZoom"
      />
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import MinerveOrbite from "@follaw-fr/components/reusable/minerve/MinerveOrbite.vue";
import DownloadButton from "@follaw-fr/components/reusable/atoms/DownloadButton.vue";
import RadioButtons from "@follaw-fr/components/reusable/atoms/RadioButtons.vue";
import NoData from "@follaw-fr/components/reusable/atoms/NoData.vue";
import GenericTimeCurve from "@follaw-fr/components/reusable/organisms/GenericTimeCurve.vue";
import GenericTimeCurveZoom from "@follaw-fr/components/reusable/organisms/GenericTimeCurveZoom.vue";
import { useTimeCurve } from "@follaw-fr/composables/useTimeCurve";
import { useLegiSocialMediaStore } from "@follaw-fr/stores/legi-social-media";

const store = useLegiSocialMediaStore();
const {
  indexesFilters,
  isTimeCurveLoading,
  isTimeCurvePublicationsLoading,
  timeCurve,
  timeCurveInterval,
  timeCurveTopDate,
  timeCurveTopArticles,
  timeCurveTopArticlesFilters,
  timeCurveTopArticlesCount,
  timeCurveTopPublications,
  timeCurveTopPublicationsCount,
  timeCurveTopPublicationsFilters,
} = storeToRefs(store);
// storeToRefs ne rend que les refs du store : une action prise par ce biais
// arrive `undefined` et le changement d'intervalle ne recharge plus la courbe.
const { fetchTimeCurve } = store;

const {
  intervalsOptions,
  changeInterval,
  closeZoom,
  downloadAsExcel,
  updateTopDate,
  updateTopArticlesFilters,
  updatePublicationsFilters,
} = useTimeCurve({
  timeCurve,
  timeCurveInterval,
  timeCurveTopDate,
  timeCurveTopArticlesFilters,
  timeCurveTopPublicationsFilters,
  fetchTimeCurve,
});
</script>

<style lang="scss" scoped>
.time-curve-wrapper {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr;
}

.wrapper {
  display: flex;
  flex-direction: column;
  grid-column: span 2;

  .card-header {
    display: flex;
    justify-content: space-between;

    .header-title {
      font-size: 1.063em;
      font-weight: 600;
      color: black;
    }

    .header-tools {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  &.zoomed {
    grid-column: span 1;
  }
}

.zoom-wrapper {
  grid-column: span 1;
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 400px;
  margin-left: auto;
  margin-right: auto;
}
</style>
